"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const R = __importStar(require("ramda"));
const PermissionsContext_1 = require("./PermissionsContext");
exports.useAllowedRoles = (roles) => {
    const context = react_1.useContext(PermissionsContext_1.PermissionsContext);
    const allowed = R.intersection(roles, context.roles).length !== 0;
    return allowed;
};
//# sourceMappingURL=useAllowedRoles.js.map